export default "/_next/static/images/book-demo-background-mobile-legacy-08c5d2d324f04ab4b4477f6c06555721.png";